export const colorsRGBA = [
  'rgba(255, 165, 0, 0.2)', // Orange
  'rgba(255, 0, 255, 0.2)', // Magenta
  'rgba(255, 255, 0, 0.2)', // Yellow
  'rgba(0, 255, 255, 0.2)', // Cyan
  'rgba(255, 0, 0, 0.2)', // Red
  'rgba(0, 255, 0, 0.2)', // Lime
  'rgba(0, 0, 255, 0.2)', // Blue
  'rgba(128, 0, 128, 0.2)', // Purple
  'rgba(0, 128, 128, 0.2)', // Teal
  'rgba(128, 0, 0, 0.2)', // Maroon
  'rgba(0, 128, 0, 0.2)', // Green
  'rgba(0, 0, 128, 0.2)', // Navy
  'rgba(255, 99, 71, 0.2)', // Tomato
  'rgba(173, 216, 230, 0.2)', // LightBlue
  'rgba(250, 128, 114, 0.2)', // Salmon
  'rgba(144, 238, 144, 0.2)', // LightGreen
  'rgba(218, 112, 214, 0.2)', // Orchid
  'rgba(240, 230, 140, 0.2)', // Khaki
  'rgba(255, 182, 193, 0.2)' // LightPink
];
